import React from "react";
import PropTypes from "prop-types";

function RoseButton({ className, onClick, disabled, children }) {
  return (
    // eslint-disable-next-line react/no-unknown-property,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div onclick="void(0);">
      <button
        type="button"
        className={`rose-btn ${className}`}
        onClick={onClick}
        disabled={disabled}
      >
        {children}
      </button>
    </div>
  );
}

RoseButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

RoseButton.defaultProps = {
  className: "",
  disabled: false,
};

export default RoseButton;
